import React, {useState} from 'react';
import {connect, DispatchProp} from "react-redux";
import {withTranslation} from "react-i18next";
import {RootState} from "../../../../../reducers";
import PromotionInfoModalComponent
    from "../../../../components/Cart/components/PromotionInfoModal/PromotionInfoModalComponent";
import ScrollableTabs from "../../../../components/Common/ScrollableTabs";
import MenuPromotionItem from "./MenuPromotionItem";
import {getStoreConfig} from "../../../../services/Store/reducer";
import MenuPromotionCoupon from "./MenuPromotionCoupon";
import StoreUtils from "../../../../services/Store/StoreUtils";
import {PromotionApi} from "../../../../services/Api/types";

interface OwnProps {
    promotions?: PromotionApi[];
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;
const MenuPromotionsComponent = ({promotions, config}: Props) => {
    const [promotionToShow, setPromotionToShow] = useState<any>();
    const isAdvertCodeBoxEnabled = config?.old_settings?.advert_code_box === "true" && !StoreUtils.isOrderingReadonly(config);
    const filteredPromotions = (promotions || []).filter(promotion => promotion.add_type !== "MANUALLY");
    const anyPromotionVisible = isAdvertCodeBoxEnabled || (filteredPromotions && filteredPromotions.length > 0);

    if (!anyPromotionVisible) return null;

    return (
        <div className={"container promotions"}>
            <ScrollableTabs hideScrollbars={false} scrollStep={200}>
                {
                    isAdvertCodeBoxEnabled && (
                        <MenuPromotionCoupon singleItem={promotions?.length === 0}/>
                    )
                }
                {
                    filteredPromotions && filteredPromotions.map((promotion) => <MenuPromotionItem key={promotion.id}
                                                                                                   singleItem={isAdvertCodeBoxEnabled ? false : filteredPromotions.length === 1}
                                                                                                   promotion={promotion}
                                                                                                   setPromotionToShow={setPromotionToShow}/>)
                }
            </ScrollableTabs>
            {promotionToShow && (
                <PromotionInfoModalComponent name={promotionToShow.name}
                                             promotionId={promotionToShow.id}
                                             onHide={() => setPromotionToShow(undefined)}/>
            )}
        </div>
    )
}


const mapStateToProps = (state: RootState) => ({
    config: getStoreConfig(state.config),
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(MenuPromotionsComponent));